"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentsEditTotalItem = void 0;
const react_1 = __importDefault(require("react"));
const Sub_1 = require("../../../Page/Title/Sub");
require("./index.scss");
const Seats_1 = require("../Seats");
const className = 'allotments-edit-total-item';
const AllotmentsEditTotalItem = (props) => {
    const { tariffs } = props;
    if (!tariffs)
        return null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__row` },
            react_1.default.createElement(Sub_1.PageSubTitle, { text: 'Malesia' })),
        react_1.default.createElement("div", { className: `${className}__row` },
            react_1.default.createElement(Seats_1.TariffsTotalSeats, { tariffs: tariffs }))));
};
exports.AllotmentsEditTotalItem = AllotmentsEditTotalItem;
//# sourceMappingURL=index.js.map